// Helper to create API clients with credentials included
export const createAuthenticatedFetch = () => {
    return {
        fetch: (url: RequestInfo, init?: RequestInit): Promise<Response> => {
            return fetch(url, {
                ...init,
                credentials: 'include', // Always send cookies
            });
        }
    };
};
